$(document).ready(function () {
    $(window).width() > 999 &&
        $(".dotBox").each(function () {
            for (var t = $(this).data("rows"), e = $(this).data("columns"), o = t * e, i = 0; i < o; i++) $(this).append("<li></li>");
            function n() {
                $(this)
                    .find("li")
                    .each(function () {
                        $(this).animate({ opacity: 0.9 * Math.random() + 0.2 }, 500);
                    }),
                    setTimeout(n.bind(this), 900);
            }
            n.call(this);
        }),
        999 > $(window).width() &&
            $(".dotBoxMobile").each(function () {
                for (var t = $(this).data("rows"), e = $(this).data("columns"), o = t * e, i = 0; i < o; i++) $(this).append("<li></li>");
                function n() {
                    $(this)
                        .find("li")
                        .each(function () {
                            $(this).animate({ opacity: 0.9 * Math.random() + 0.2 }, 500);
                        }),
                        setTimeout(n.bind(this), 900);
                }
                n.call(this);
            }),
        $(".sector-selector").on("click", function () {
            $(".sector-selector.activeSelector").removeClass("activeSelector"), $(this).addClass("activeSelector");
            var t = $(this).data("toggle");
            $(".sector-sliderContainer").css({ opacity: 0 }),
                $(".sector-sliderContainer." + t)
                    .css({ display: "block" })
                    .animate({ opacity: 1 }, 200),
                setTimeout(function () {
                    $(".sector-sliderContainer:not(." + t + ")").css("display", "none");
                }, 10);
        });
}),
    $(window).width() > 999 &&
        (function (t) {
            t.fn.visible = function (e) {
                var o = t(this),
                    i = t(window),
                    n = t(window).height(),
                    s = i.scrollTop(),
                    a = o.offset().top,
                    r = a + o.height();
                return (!0 === e ? a : r) <= s + n && (!0 === e ? r : a) >= s;
            };
        })(jQuery),
    1e3 > $(window).width() &&
        (function (t) {
            t.fn.visible = function (e) {
                var o = t(this),
                    i = t(window),
                    n = t(window).height() + 80,
                    s = i.scrollTop(),
                    a = o.offset().top,
                    r = a + o.height();
                return (!0 === e ? a : r) <= s + n && (!0 === e ? r : a) >= s;
            };
        })(jQuery);
var win = $(window),
    allMods = $(".module");
function injectSVG(t) {
    var e = t.data("svg");
    $.get(e, function (o) {
        var i = $("<img />", { src: e });
        t.html(i);
    });
}
allMods.each(function (t, e) {
    var e = $(e);
    e.visible(!0) && (e.addClass("already-visible"), injectSVG(e.find(".icon-animation")), e.data("svg-injected", !0));
}),
    win.scroll(function (t) {
        allMods.each(function (t, e) {
            var e = $(e);
            e.visible(!0) && !e.data("svg-injected") && (e.addClass("come-in"), injectSVG(e.find(".icon-animation")), e.data("svg-injected", !0));
        });
    }),
    $(".byProduct").on("click", function () {
        $(".byProduct.active").removeClass("active"), $(this).addClass("active");
    });
class Demo {
    constructor() {
        this.initCursor(), this.initHovers();
    }
    initCursor() {
        let { Back: t } = window;
        (this.outerCursor = document.querySelector(".circle-cursor--outer")),
            (this.innerCursor = document.querySelector(".circle-cursor--inner")),
            (this.outerCursorBox = this.outerCursor.getBoundingClientRect()),
            (this.outerCursorSpeed = 0),
            (this.easing = t.easeOut.config(1.7)),
            (this.clientX = -100),
            (this.clientY = -100),
            (this.showCursor = !1);
        let e = () => {
            TweenMax.set(this.innerCursor, { x: this.clientX, y: this.clientY }),
                TweenMax.set(this.outerCursor, { x: this.clientX - this.outerCursorBox.width / 2, y: this.clientY - this.outerCursorBox.height / 2 }),
                setTimeout(() => {
                    this.outerCursorSpeed = 0.01;
                }, 100),
                (this.showCursor = !0);
        };
        document.addEventListener("mousemove", e),
            document.addEventListener("mousemove", (t) => {
                (this.clientX = t.clientX), (this.clientY = t.clientY);
            });
        let o = () => {
            TweenMax.set(this.innerCursor, { x: this.clientX, y: this.clientY }),
                this.isStuck || TweenMax.to(this.outerCursor, this.outerCursorSpeed, { x: this.clientX - this.outerCursorBox.width / 2, y: this.clientY - this.outerCursorBox.height / 2 }),
                this.showCursor && document.removeEventListener("mousemove", e),
                requestAnimationFrame(o);
        };
        requestAnimationFrame(o);
    }
    initHovers() {
        let t = TweenMax.to(this.outerCursor, 0.3, { backgroundColor: "#D7C1A9", ease: this.easing, paused: !0, opacity: 0.8 }),
            e = () => {
                (this.outerCursorSpeed = 0), TweenMax.set(this.innerCursor, { opacity: 1, backgroundColor: "#000" }), t.play();
            },
            o = () => {
                (this.outerCursorSpeed = 0.2), TweenMax.set(this.innerCursor, { opacity: 1, backgroundColor: "#D7C1A9" }), t.reverse();
            },
            i = document.querySelectorAll("a, .trigger, .accordion__toggle, .filterBox, .tap-area, .flickity-prev-next-button, button");
        i.forEach((t) => {
            t.addEventListener("mouseenter", e), t.addEventListener("mouseleave", o);
        });
    }
}
const demo = new Demo();
$(function () {
    $(document).bind("beforecreate.offcanvas", function (t) {
        var e = $(t.target).data("offcanvas-component");
        console.log(e),
            (e.onInit = function () {
                console.log(this);
            });
    }),
        $(document).bind("create.offcanvas", function (t) {
            var e = $(t.target).data("offcanvas-component");
            console.log(e),
                (e.onOpen = function () {
                    console.log("Callback onOpen"), $("body").addClass("offcanvas-open");
                }),
                (e.onClose = function () {
                    console.log("Callback onClose"), $("body").removeClass("offcanvas-open");
                });
        }),
        $(document).bind("clicked.offcanvas-trigger clicked.offcanvas", function (t) {
            var e = $(t.target).text();
            console.log(t.type + "." + t.namespace + ": " + e);
        }),
        $(document).bind("open.offcanvas", function (t) {
            var e = $(t.target).attr("id");
            console.log(t.type + ": #" + e);
        }),
        $(document).bind("resizing.offcanvas", function (t) {
            var e = $(t.target).attr("id");
            console.log(t.type + ": #" + e);
        }),
        $(document).bind("close.offcanvas", function (t) {
            var e = $(t.target).attr("id");
            console.log(t.type + ": #" + e);
        }),
        $(".js-open").bind("create.offcanvas", function (t) {
            $(this).data("offcanvas-component"), setTimeout(function () {}, 200);
        }),
        $(document).bind("beforecreate.offcanvas", function (t) {
            var e = $(t.target),
                o = e.data("offcanvas-component");
            e.on("focusin", "input,textarea", function t() {
                console.log("onFocusIn"), (o.options.resize = !1), console.log(o.options.resize), $(window).off("resize.offcanvas orientationchange.offcanvas");
            }).on("focusout", "input,textarea", function t() {
                console.log("onFocusOut"), (o.options.resize = !0), console.log(o.options.resize), $(window).on("resize.offcanvas orientationchange.offcanvas"), o.resize();
            });
        }),
        $(document).trigger("enhance");
}),
    (window.onload = function () {
        setTimeout(function () {
            document.querySelector(".hiddenOnLoad").classList.remove("hiddenOnLoad");
        }, 500);
    });
const offcanvasElements = document.querySelectorAll(".js-offcanvas");
offcanvasElements.forEach((t) => {
    let e = t.previousElementSibling,
        o = new MutationObserver((o) => {
            let i = t.classList.contains("is-open");
            i ? e.classList.add("open") : e.classList.remove("open");
        });
    o.observe(t, { attributes: !0 });
}),
$(document).ready(function () {
    $("h1, h2, h3, h4, h5, h6, p, .hasH2, .link-faded, .text-subdued, .tag, .h3, a").each(function () {
        var $element = $(this);
        var originalHtml = $element.html();
        
        if (originalHtml.includes("H2")) {
            // Replace "H2" with "H<sup>2</sup>" while preserving spaces
            var newHtml = originalHtml.replace(/H2(\s|$)/g, "H<sup>2</sup>$1");
            $element.html(newHtml);
        }
    });
});


/* before after */
$('.imageBox').hover(function () {
  $('.imageBox.initial').removeClass('initial');
  $('.imageBox.on').removeClass('on');
  $(this).addClass('on');
});



/* GSAP ANIMATIONS */

/* smooth scroll 
<script src='https://cdn.jsdelivr.net/npm/locomotive-scroll@3.5.4/dist/locomotive-scroll.min.js'></script>

const scroller = new LocomotiveScroll({
  el: document.querySelector("#main"),
  smooth: true
});
*/

/* Img animation */
const options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.9
};

let revealCallback = (entries, self) => {
  entries.forEach((entry) => {
    let container = entry.target;
    let img = entry.target.querySelector("img");
    const easeInOut = "power3.out";
    const revealAnim = gsap.timeline({ ease: easeInOut });

    if (entry.isIntersecting) {
      revealAnim.set(container, {
        visibility: "visible"
      });
      revealAnim.fromTo(
        container,
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          webkitClipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)"
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          webkitClipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          duration: 1,
          ease: easeInOut
        }
      );
      revealAnim.from(img, 4, {
        scale: 1.4,
        ease: easeInOut,
        delay: -1
      });
      self.unobserve(entry.target);
    }
  });
};

let revealObserver = new IntersectionObserver(revealCallback, options);

document.querySelectorAll(".reveal").forEach((reveal) => {
  revealObserver.observe(reveal);
});


// text reveal up
gsap.utils.toArray(".animation-appear").forEach(element => {
  gsap.fromTo(element, 
    {
      yPercent: 0,
      scale: .85,
      opacity: 0,
    },         
    {
      duration: 0.8,
      delay: 1,
      opacity: 1,
      scale: 1,
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
    
      scrollTrigger: {
          trigger: element,
          start: "top 120%",
          end: "50% 50%",
          scrub: 0.8,
          //markers: true
        }
    });
  }
);

/*
$(document).ready(function() {
    $(window).scroll(function() {
        var scroller = $("#shopify-section-template--22185544188248__rich_text_JDx6eR");
        var scrollTop = window.pageYOffset;
        var scrollHeight = scroller.prop('scrollHeight');
        var height = scroller.height();
        var windowHeight = $(window).height();

        console.log("scroller:", scroller);
        console.log("scrollTop:", scrollTop);
        console.log("scrollHeight:", scrollHeight);
        
        console.log("height:", height);
        console.log('total:', windowHeight + scrollTop);

      
        if (scrollTop + windowHeight >= scrollTop - height) {
            console.log("Scroller completely scrolled through!");
            scroller.addClass("isBottomed");
        } else {
            scroller.removeClass("isBottomed");
        }
    });
});
*/
/*
$(document).ready(function() {
    $("#shopify-section-template--22185544188248__rich_text_JDx6eR").scroll(function() {
        var scrollBlock = $(this);
        var scrollHeight = scrollBlock.prop('scrollHeight');
        var scrollTop = scrollBlock.scrollTop();
        var height = scrollBlock.height();

        if (scrollTop + height >= scrollHeight) {
            scrollBlock.addClass("Bottomed");
        } else {
            scrollBlock.removeClass("Bottomed");
        }
    }).trigger('scroll'); // Trigger scroll event once on page load
});
*/

gsap.utils.toArray(".animation-widden").forEach(element => {
  gsap.fromTo(element, 
    {
      yPercent: 0,
      clipPath: 'inset(0 10%)',
    },         
    {
      duration: 0.8,
      delay: 1,
      clipPath: 'inset(0 0%)',
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "50% 50%",
        scrub: 0.8,
        //markers: true
      }
    });
  }
);

gsap.utils.toArray(".animation-widden-video").forEach(element => {
  gsap.fromTo(element, 
    {
      borderRadius: "500px",
      scale: .9,
    },         
    {
      duration: 0.8,
      delay: 1,
      scale: 1,
      borderRadius: "20px",
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "50% 50%",
        scrub: 0.8,
        //markers: true
      }
    });
  }
);

/*
gsap.utils.toArray(".animation-fade-out").forEach(element => {
  gsap.fromTo(element, 
    {
      scale: 1,
      opacity: 1,
    },         
    {
      duration: 0.8,
      delay: 1,
      scale: .9,
      opacity: 1,
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "100% 70%",
        end: "100% 10%",
        scrub: 0.8,
        //markers: true
        }
      });
  }
);
*/

gsap.utils.toArray(".animation-fade-out").forEach(element => {
  gsap.fromTo(element, 
    {
      scale: 1,
      borderRadius: "0rem",
      opacity: 1,
    },         
    {
      duration: 0.8,
      delay: 1,
      scale: .98,
      borderRadius: "20px",
      opacity: 1,
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "100% 80%",
        end: "100% 25%",
        scrub: 0.8,
        //markers: true
        }
      });
  }
);




/* VIDEO SCROLL */
/*
const bgVvideo = document.querySelector("#bgVideo");

bgVideo.pause();
bgVideo.currentTime = 0;

const stickyEls = document.querySelectorAll('.step');

stickyEls.forEach(el => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: 'bottom 80%',
      end: 'bottom 20%',
      //markers: true,
      toggleActions: 'play none reverse none',
      scrub: 1
    }
  });
  tl.from(el, {opacity: 0}),
  tl.to(el, {opacity: 0})
})


let sections = gsap.utils.toArray(".step");
sections.forEach((step, i) => {

    gsap.fromTo(bgVideo, { currentTime: 1 * i }, {
        scrollTrigger: {
            trigger: step,
            scrub: 2,
            start: "top bottom",
            end: "bottom bottom",
        },
        currentTime: 1 * (i + 1),
        ease: "power",
        stagger: 0.2,
    });
});
*/
/* SMOOTH SCROLL 
gsap.registerPlugin(ScrollSmoother);

// create the smooth scroller FIRST!
const smoother = ScrollSmoother.create({
 wrapper: "body",
 content: "#main",
 smooth: 1,
 normalizeScroll: true, // prevents address bar from showing/hiding on most devices, solves various other browser inconsistencies
 ignoreMobileResize: true, // skips ScrollTrigger.refresh() on mobile resizes from address bar showing/hiding
 effects: true,
 preventDefault: true
});

gsap.set(".container", {
 yPercent: -150,
 opacity: 1
});

let tl = gsap.timeline();
let mySplitText = new SplitText("#split-stagger", { type: "words,chars" });
let chars = mySplitText.chars;

chars.forEach((char, i) => {
 smoother.effects(char, { speed: 1, lag: (i + 1) * 0.1 });
});
*/


/* ANIMATE IN AND OUT 
gsap.utils.toArray(".slideshow__slide").forEach(element => {
  gsap.fromTo(element, 
    {
      yPercent: 0,
      scale: .85,
      opacity: .7,
    },         
    {
      duration: 0.8,
      delay: 1,
      scale: 1,
      opacity: 1,
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "-30% 70%",
        end: "20% 70%",
        scrub: 0.8,
        markers: true
        }
      });
  }
);

gsap.utils.toArray(".slideshow__slide").forEach(element => {
  gsap.fromTo(element, 
    {},         
    {
      duration: 0.8,
      delay: 1,
      scale: .85,
      opacity: .7,
      yPercent: 0,
      ease: "power",
      stagger: 0.02,
      
      scrollTrigger: {
        trigger: element,
        start: "100% 70%",
        end: "100% 10%",
        scrub: 0.8,
        markers: true
        }
      });
  }
);
END ANIMATE IN AND OUT */


/*
gsap.utils.toArray(".shopify-section--video").forEach(element => {
 
  gsap.fromTo(element, 
    {
    yPercent: -5,
    //scale: .85,
    //opacity: 0,
    clipPath: 'inset(0 15%)',
    },         
    {
    duration: 0.8,
    delay: 1,
    //opacity: 1,
    clipPath: 'inset(0 0%)',
    //scale: 1,
    yPercent: 0,
    ease: "power",
    stagger: 0.02,
    
   scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "50% 50%",
      scrub: 0.8,
      markers: true
      }
    });
  });
*/

/*
gsap.utils.toArray(".collection-card").forEach(element => {
 
  gsap.fromTo(element, 
    {
    yPercent: 30,
    opacity: 0,
    },         
    {
    duration: 0.8,
    delay: 1,
    opacity: 1,
    yPercent: 0,
    ease: "power",
    stagger: 0.02,
    
   scrollTrigger: {
      trigger: element,
      start: "top 120%",
      end: "50% 50%",
      scrub: 0.3,
      markers: true
      }
    });
  });
*/

